<div class="l-row">
  <div class="l-col--side l-col--sideNavigation l-col--sideLeft"></div>
  <div id="InfoPage" class="l-col--main">
    <div *ngIf="emailSending">
      <p>
        <span *ngIf="generalService.translationMode === true">
          (CN002)
        </span>
        {{ "CONTACT.CN002.value" | translate }}...
      </p>
    </div>

    <div *ngIf="emailSent">
      <p>
        <span *ngIf="generalService.translationMode === true">
          (CN003)
        </span>
        {{ "CONTACT.CN003.value" | translate }}
      </p>
    </div>

    <!-- ----------------------  contact form starts --------------------------------- -->

    <div class="" *ngIf="!emailSending && !emailSent">
      <div class="c-block__header">
        <h2 class="c-block__title">
          <span *ngIf="generalService.translationMode === true">
            (G036)
          </span>
          {{ "GLOBAL.G036.value" | translate }}
        </h2>
        <p>
          <span *ngIf="generalService.translationMode === true">
            (CN001)
          </span>
          {{ "CONTACT.CN001.value" | translate }}
        </p>
      </div>
      <div class="c-block__body c-block__body--compact">
        <!-- NAME INPUT -->
        <dl class="c-dl--row c-dl--lg c-dl--first">
          <dt class="c-dl__title c-formGroup__label--req">
            <span *ngIf="generalService.translationMode === true">
              (G007)
            </span>
            {{ "GLOBAL.G007.value" | translate }}
          </dt>
          <dd class="c-dl__body">
            <div class="c-dataBox">
              <div class="c-dataBox__body c-formGroup__control">
                <input
                  required
                  #name="ngModel"
                  type="text"
                  id="name"
                  name="name"
                  class="c-input"
                  [(ngModel)]="contactForm.name"
                  [placeholder]="
                    generalService.translationMode === true
                      ? '(A001) ' + ('AUTH.A001.value' | translate)
                      : ('AUTH.A001.value' | translate)
                  "
                />

                <div
                  *ngIf="name.invalid && (name.dirty || name.touched)"
                  class="c-formGroup c-formGroup--notValid"
                >
                  <div
                    *ngIf="name.errors.required"
                    class="c-formGroup__helpText"
                  >
                    <span *ngIf="generalService.translationMode === true">
                      (G007)
                    </span>
                    {{ "GLOBAL.G007.value" | translate }}

                    <span *ngIf="generalService.translationMode === true">
                      (G031)
                    </span>
                    {{ "GLOBAL.G031.value" | translate }}
                  </div>
                </div>

                <div></div>
              </div>
            </div>
          </dd>
        </dl>

        <!-- Email INPUT -->
        <dl class="c-dl--row c-dl--lg">
          <dt class="c-dl__title c-formGroup__label--req">
            <span *ngIf="generalService.translationMode === true">
              (G008)
            </span>
            {{ "GLOBAL.G008.value" | translate }}
          </dt>
          <dd class="c-dl__body">
            <div class="c-dataBox">
              <div class="c-dataBox__body c-formGroup__control">
                <input
                  class="c-input"
                  required
                  email
                  #email="ngModel"
                  type="email"
                  id="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                  name="email"
                  [(ngModel)]="contactForm.email"
                  [placeholder]="'GLOBAL.G008.value' | translate"
                />
                <div
                  *ngIf="email.invalid && (email.dirty || email.touched)"
                  class="c-formGroup c-formGroup--notValid"
                >
                  <div
                    *ngIf="email.errors.required"
                    class="c-formGroup__helpText"
                  >
                    <span *ngIf="generalService.translationMode === true">
                      (G008)
                    </span>
                    {{ "GLOBAL.G008.value" | translate }}

                    <span *ngIf="generalService.translationMode === true">
                      (G031)
                    </span>
                    {{ "GLOBAL.G031.value" | translate }}
                  </div>
                  <div
                    *ngIf="email.errors.pattern"
                    class="c-formGroup__helpText"
                  >
                    <span *ngIf="generalService.translationMode === true">
                      (G032)
                    </span>
                    {{ "GLOBAL.G032.value" | translate }}
                    <span *ngIf="generalService.translationMode === true">
                      (G008)
                    </span>
                    {{ "GLOBAL.G008.value" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <!--  Phone INPUT -->
        <dl class="c-dl--row c-dl--lg">
          <dt class="c-dl__title c-formGroup__label--req">
            <span *ngIf="generalService.translationMode === true">
              (G009)
            </span>
            {{ "GLOBAL.G009.value" | translate }}
          </dt>
          <dd class="c-dl__body">
            <div class="c-dataBox">
              <div class="c-dataBox__body c-formGroup__control">
                <input
                  required
                  id="phone"
                  name="phone"
                  #phone="ngModel"
                  class="c-input"
                  [(ngModel)]="contactForm.phone"
                  min="8"
                  [placeholder]="
                    generalService.translationMode === true
                      ? '(G010) ' + ('GLOBAL.G010.value' | translate)
                      : ('GLOBAL.G010.value' | translate)
                  "
                  (keyup)="phoneChange($event)"
                  type="text"
                  pattern="[+]?\d*"
                />

                <div class="c-formGroup c-formGroup--notValid">
                  <div *ngIf="phone.invalid && (phone.dirty || phone.touched)">
                    <div
                      *ngIf="phone.errors.required"
                      class="c-formGroup__helpText"
                    >
                      <span *ngIf="generalService.translationMode === true">
                        (G009)
                      </span>
                      {{ "GLOBAL.G009.value" | translate }}

                      <span *ngIf="generalService.translationMode === true">
                        (G031)
                      </span>
                      {{ "GLOBAL.G031.value" | translate }}
                    </div>

                    <div
                      *ngIf="phone.errors.pattern"
                      class="c-formGroup__helpText"
                    >
                      <span *ngIf="generalService.translationMode === true">
                        (G010)
                      </span>
                      {{ "GLOBAL.G010.value" | translate }}
                      <span *ngIf="generalService.translationMode === true">
                        (G032)
                      </span>
                      {{ "GLOBAL.G032.value" | translate }}
                    </div>
                  </div>

                  <div
                    *ngIf="errors.customerPhoneError && !phone.errors"
                    class="c-formGroup__helpText"
                  >
                    <span *ngIf="generalService.translationMode === true">
                      (C032)
                    </span>
                    {{ "CART.C032.value" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <!--  Message INPUT -->
        <dl class="c-dl--row c-dl--lg">
          <dt class="c-dl__title c-formGroup__label--req">
            <span *ngIf="generalService.translationMode === true">
              (G037)
            </span>
            {{ "GLOBAL.G037.value" | translate }}
          </dt>
          <dd class="c-dl__body">
            <div class="c-dataBox">
              <div class="c-dataBox__body c-formGroup__control">
                <textarea
                  required
                  type=""
                  class="c-input"
                  id="message"
                  name="message"
                  #message="ngModel"
                  [(ngModel)]="contactForm.message"
                  [placeholder]="
                    generalService.translationMode === true
                      ? '(G037) ' + ('GLOBAL.G037.value' | translate)
                      : ('GLOBAL.G037.value' | translate)
                  "
                ></textarea>
                <div class="c-formGroup c-formGroup--notValid">
                  <div
                    *ngIf="
                      message.invalid && (message.dirty || message.touched)
                    "
                  >
                    <div
                      *ngIf="message.errors.required"
                      class="c-formGroup__helpText"
                    >
                      <span *ngIf="generalService.translationMode === true">
                        (G037)
                      </span>
                      {{ "GLOBAL.G037.value" | translate }}

                      <span *ngIf="generalService.translationMode === true">
                        (G031)
                      </span>
                      {{ "GLOBAL.G031.value" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <button
          class="b--lg"
          [ngClass]="
            (email.errors && (email.errors.required || email.errors.pattern)) ||
            (phone.errors && (phone.errors.required || phone.errors.pattern)) ||
            errors.customerPhoneError ||
            (message.errors && message.errors.required) ||
            (name.errors && name.errors.required)
              ? 'b-default'
              : 'b-action'
          "
          [disabled]="
            (email.errors && (email.errors.required || email.errors.pattern)) ||
            (phone.errors && (phone.errors.required || phone.errors.pattern)) ||
            errors.customerPhoneError ||
            (message.errors && message.errors.required) ||
            (name.errors && name.errors.required)
          "
          (click)="sendMail()"
        >
          <span *ngIf="generalService.translationMode === true">
            (G038)
          </span>
          {{ "GLOBAL.G038.value" | translate }}
        </button>
      </div>
    </div>

    <!-- ----------------------  contact form ends --------------------------------- -->
  </div>
  <div class="l-col--side l-col--sideNavigation l-col--sideRight"></div>
</div>
